import { createVerticalFlowAnalytics } from "../VerticalFlowComponents/analytics";

export const virtualMachineVerticalFlowAnalytics = createVerticalFlowAnalytics("VM Dynamic Supply");
